import React from 'react';

/**
 * Placeholder content untuk halaman yang belum diimplementasikan
 * @param {string} title - Judul halaman
 * @param {boolean} isDarkMode - Status dark mode
 */
const PlaceholderContent = ({ title, isDarkMode }) => (
    <div className={`p-8 text-center rounded border ${isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
        <p className="text-sm text-slate-500">Content for {title}</p>
    </div>
);

export default PlaceholderContent;
